import React from 'react';
import { IHelpArticle } from './help-articles';
import { getTheme, IStyle, ITheme, mergeStyleSets } from '@fluentui/react';

interface IPRIVATE_MARKDOWN_HELP_VIEWER_PILLProps {
  article: IHelpArticle;
  isActive: boolean;
  onPillSelected: (article: IHelpArticle) => void;
}

const getStyleClasses = (theme: ITheme) => {
  const pillSize = 16;

  const contentContainer: IStyle = {
    padding: 0,
    margin: 0,
    flexGrow: 1,
  };

  const pill: IStyle = {
    height: pillSize * 2,
    borderRadius: pillSize,
    margin: 0,
    marginRight: pillSize / 2,
    marginBottom: pillSize / 2,
    padding: 0,
    paddingLeft: pillSize,
    paddingRight: pillSize,
    display: 'flex',
    flexDirection: 'row',
    boxSizing: 'border-box',
    cursor: 'pointer',
  };

  const activePill: IStyle = {
    ...pill,
    border: 'none',
    backgroundColor: theme.palette.themePrimary,
    color: theme.palette.white,

    '&:hover': {
      backgroundColor: theme.palette.themeSecondary,
    },
  };

  const defaultPill: IStyle = {
    ...pill,
    border: `1px solid ${theme.palette.themePrimary}`,
    backgroundColor: 'transparent',
    color: theme.palette.themePrimary,

    '&:hover': {
      border: `1px solid ${theme.palette.themeSecondary}`,
      color: theme.palette.themeSecondary,
    },
  };

  const content: IStyle = {
    padding: 0,
    margin: 0,
    fontSize: pillSize,
    color: 'inherit',
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: pillSize * 2,
    textAlign: 'center',
    boxSizing: 'border-box',
    cursor: 'pointer',
  };

  return mergeStyleSets({
    contentContainer,
    activePill,
    defaultPill,
    content,
  });
}

export const PRIVATE_MARKDOWN_HELP_VIEWER_PILL: React.FunctionComponent<IPRIVATE_MARKDOWN_HELP_VIEWER_PILLProps> = (props) => {
  const { article, isActive, onPillSelected } = props;
  const theme = getTheme();
  const styles = getStyleClasses(theme);

  return (
    <div
      className={isActive ? styles.activePill : styles.defaultPill}
      onClick={() => onPillSelected(article)}
    >
      <div className={styles.contentContainer}>
        <p className={styles.content}>{article.title}</p>
      </div>
    </div>
  );
};
